import * as actions from "./actionTypes";

export const personalDetailsForm = (
  state = {
    data: {},
    isLoading: false,
    errors: {},
  },
  action,
) => {
  switch (action.type) {
    case actions.SUBMIT_PERSONAL_DETAILS_FORM_START:
      return {
        ...state,
        isLoading: true,
        errors: {},
      };
    case actions.SUBMIT_PERSONAL_DETAILS_FORM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        errors: {},
      };
    case actions.SUBMIT_PERSONAL_DETAILS_FORM_FAILURE:
      return {
        data: [],
        isLoading: false,
        errors: action.errors,
      };

    default:
      return state;
  }
};

export const changePasswordForm = (
  state = {
    data: {},
    isLoading: false,
    errors: {},
  },
  action,
) => {
  switch (action.type) {
    case actions.SUBMIT_CHANGE_PASSWORD_FORM_START:
      return {
        ...state,
        isLoading: true,
        errors: {},
      };
    case actions.SUBMIT_CHANGE_PASSWORD_FORM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        errors: {},
      };
    case actions.SUBMIT_CHANGE_PASSWORD_FORM_FAILURE:
      return {
        data: [],
        isLoading: false,
        errors: action.errors,
      };

    default:
      return state;
  }
};
